module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Billigform.dk","short_name":"Billigform","start_url":"/","background_color":"#fff","theme_color":"#040a0a","display":"minimal-ui","icon":"src/images/csicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"79b7781d82a2f8820fffcbafff7c1890"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
